<template>
  <v-card
    class="py-4 px-3 questionnaire"
    style="border-radius:10px"
  >
    <h3 class="mt-0 text-xs-center title text-metal-blue">
      ミニアンケートにご協力ください..！
    </h3>

    <v-divider class="hr mt-2" />

    <v-form
      v-model="form"
      class="text-xs-center"
    >
      <div class="section-wrapper">
        <p>GoNOWの使い勝手は期待通りですか？</p>
        <v-radio-group
          v-model="rg1"
          class="radio-btns"
          name="rg1"
          :error="!rg1"
          row
        >
          <v-radio
            v-for="i in 5"
            :key="i"
            color="metalBlue"
            :value="i"
            class="mx-2"
          />
        </v-radio-group>
        <span class="helper-text">そう思わない</span>
        <span class="helper-text">そう思う</span>
      </div>

      <v-divider class="hr" />

      <div class="section-wrapper">
        <p>GoNOWを同僚や知人の会社におすすめしたいと思いますか？</p>
        <v-radio-group
          v-model="npsValue"
          class="radio-btns"
          name="npsValue"
          :error="npsValue == null"
          row
        >
          <v-radio
            v-for="i in 11"
            :key="i"
            color="metalBlue"
            class="mx-1"
            :value="i-1"
          />
        </v-radio-group>
        <span class="helper-text">そう思わない</span>
        <span class="helper-text">そう思う</span>
      </div>

      <v-divider class="hr" />

      <p class="mb-2">
        その他、ご意見等ございましたらご記入お願いします。（任意）
      </p>
      <v-textarea
        v-model.trim="opinions"
        class="mt-0 pt-1 mx-auto"
        color="metalBlue"
        outline
        single-line
        no-resize
        rows="3"
        style="max-width: 84%;"
      />
      <v-layout
        class="survey-btns"
        row
      >
        <v-flex
          xs9
          style="display:flex"
        >
          <v-btn
            class="mx-3"
            color="red darken-3"
            outline
            small
            data-cy="reject"
            @click="submitQuestionnaire(false)"
          >
            <span class="btn-text font-weight-bold">回答しない</span>
          </v-btn>
          <v-btn
            small
            data-cy="later"
            @click="setShowQuestionnaire(false)"
          >
            <span class="btn-text">後で</span>
          </v-btn>
        </v-flex>
        <v-flex
          xs3
          style="
          display:flex;
          justify-content:flex-end"
        >
          <v-btn
            color="success"
            :disabled="!form"
            class="mr-3"
            data-cy="submit"
            @click="submitQuestionnaire"
          >
            <span
              class="btn-text font-weight-bold"
            >回答する</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Questionnaire',
  data () {
    return {
      rg1: null,
      npsValue: null,
      opinions: '',
      form: false
    }
  },
  computed: {
    ...mapState('auth', ['token'])
  },
  methods: {
    ...mapMutations('app', ['setShowQuestionnaire', 'setGlobalSnackBarText']),
    submitQuestionnaire (submit = true) {
      if (submit && !this.form) return
      const body = {
        'is_answered': submit ? 'true' : 'false',
        'as_expected': submit ? String(this.rg1) : '',
        'nps_value': submit ? String(this.npsValue) : '',
        'opinions_and_requests': this.opinions
      }
      this.makeRequest(body)
      this.setShowQuestionnaire(false)
    },
    async makeRequest (body) {
      await fetch(process.env.SURVEY_SUBMIT, {
        method: 'POST',
        headers: {
          authorization: this.token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })

      if (body.is_answered === 'true') {
        this.setGlobalSnackBarText('アンケートを送信しました。ご協力ありがとうございます!')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire {
  position: fixed;
  z-index: 1000;
  width: 550px;
  bottom: 0;
  right: 0;
  margin: 0;
  transform-origin: 100% 100%;
}
p {
  margin: 0;
}
.section-wrapper {
  position: relative;
  width: max-content;
  margin: 0 auto;
}
.helper-text {
  position: absolute;
  white-space: nowrap;
  color: rgba(71, 71, 71, 0.918);
  font-size: 0.85rem;
  bottom: -1rem;
  &:first-of-type {
    left: -1rem;
  }
  &:last-of-type {
    right: -1rem;
  }
}
.hr {
  margin-bottom: 20px !important;
}
.btn-text {
  font-size: 0.9rem;
}
.radio-btns{
  margin: 8px 0 26px;
  justify-content: center;

  /deep/ {
    .theme--light.v-icon{
      color: rgba(71, 71, 71, 0.918);
    }
    .error--text, .v-messages {
      min-height: 0;
      color: rgba(71, 71, 71, 0.918)!important;
    }
  }
}
</style>
